import { SourceType } from "@authory-packages/core";

export const showRssSourceUrlField = [
  SourceType.PodcastRssFeed,
  SourceType.RssFeed,
];
